import React, { useState } from "react";

export function CenterCreditModal({
  show,
  onClose,
  centerData,
  agentList,
  onSave,
}) {
  const [formData, setFormData] = useState(centerData || {});

  const fieldDependencies = {
    notification_flag: () => ({}),
    notification_type: () => ({}),
    credit_limit: () => ({}),
    credit_days: () => ({}),
    reminder_days_before: () => ({}),
    grace_days: () => ({}),
    deactivate_after_days: () => ({}),
    frozen_flag: () => ({}),
    agent_commission_type: () => ({}),
    agent_commission_perc_or_amount: () => ({}),
    agent_commission_include_ecg: () => ({}),
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    let changeValue = '';
    if(name==='review_flag' || name==='notification_flag' 
      || name==='frozen_flag' || name==='notification_type'
      || name==='agent_commission_type' || name==='agent_commission_include_ecg'      
    ){
      changeValue = value;
    }
    else{
      changeValue = Number(value);
    }

    setFormData((prev) => {
      let updated = { ...prev, [name]: changeValue };

      if (fieldDependencies[name]) {
        updated = {
          ...updated,
          ...fieldDependencies[name](changeValue, prev),
        };
      }

      return updated;
    });
  };

  return (
    <div className="centered-modal" style={{zIndex:"21055"}}>
      <div className="modal-header pt-2">
          <span className="close" id="close-button" onClick={onClose}>&times;</span>
          <h6 className="mb-0"><i className="bi bi-person-circle"></i> Credit Control: {formData?.center_name}</h6>
      </div>
      <div className="modal-body" style={{paddingTop:"0.5px"}}>
        <div className="modal-row">
          <div className="modal-column input-group-text" style={{textAlign:"left"}}>
            <b>Notification</b>
          </div>
        </div>
        <div className="modal-row">
          <div className="modal-column">
            <label>
              Notification:
              <select
                className="modal-input"
                id="ddlnotification_flag"
                name="notification_flag"
                onChange={handleChange}
              >
                <option value="N"
                  selected={"N" === formData?.notification_flag}
                >No</option>
                <option value="Y"
                  selected={"Y" === formData?.notification_flag}
                >Yes</option>
              </select>

            </label>
          </div>
          <div className="modal-column">
            <label>
              Type:
              <select
                className="modal-input"
                id="ddlnotification_type"
                name="notification_type"
                onChange={handleChange}
              >
                <option value="NONE"
                  selected={"NONE" === formData?.notification_type}
                >None</option>
                <option value="INTERNAL"
                  selected={"INTERNAL" === formData?.notification_type}
                >Internal</option>
                <option value="EMAIL"
                  selected={"EMAIL" === formData?.notification_type}
                >E-mail</option>
                <option value="EMAILIN"
                  selected={"EMAILIN" === formData?.notification_type}
                >Internal & E-mail</option>
                <option value="SMS"
                  selected={"SMS" === formData?.notification_type}
                >SMS</option>
                <option value="WHATSAPP"
                  selected={"WHATSAPP" === formData?.notification_type}
                >WhatsApp</option>
                <option value="SMSWA"
                  selected={"SMSWA" === formData?.notification_type}
                >SMS & WhatsApp</option>
                <option value="SMSWAIN"
                  selected={"SMSWAIN" === formData?.notification_type}
                >Internal, SMS & WhatsApp</option>
                <option value="SMSWAEM"
                  selected={"SMSWAEM" === formData?.notification_type}
                >E-mail, SMS & WhatsApp</option>
                <option value="SMSWAEMIN"
                  selected={"SMSWAEMIN" === formData?.notification_type}
                >Internal, E-mail, SMS & WhatsApp</option>
              </select>

            </label>
          </div>
        
          <div className="modal-column">
            <label>
              Reminder Before:
              <input
                type="number"
                name="reminder_days_before"
                value={formData?.reminder_days_before ?? ""}
                className="modal-input"
                onChange={handleChange}
                min={0}
              />

            </label>
          </div>
          <div className="modal-column">
            <label>
              Grace Days:
              <input
                type="number"
                name="grace_days"
                value={formData?.grace_days ?? ""}
                className="modal-input"
                onChange={handleChange}
                min={0}
              />

            </label>
          </div>
        </div>

        <div className="modal-row">
          <div className="modal-column input-group-text">
            <b>Credit Policy</b>
          </div>
        </div>

        <div className="modal-row">
          <div className="modal-column">
            <label>
              Credit Limit:
              <input
                type="number"
                name="credit_limit"
                value={formData?.credit_limit ?? ""}
                className="modal-input"
                onChange={handleChange}
                min={0}
              />
            </label>
          </div>
          <div className="modal-column">
            <label>
              Credit Days:
              <input
                type="number"
                name="credit_days"
                value={formData?.credit_days ?? ""}
                className="modal-input"
                onChange={handleChange}
                min={0}
              />

            </label>
          </div>
        
          <div className="modal-column">
            <label title="Center account will be de-activated after this days.">
              De-active After:
              <input
                type="number"
                name="deactivate_after_days"
                value={formData?.deactivate_after_days ?? ""}
                className="modal-input"
                onChange={handleChange}
                min={0}
              />

            </label>
          </div>

          <div className="modal-column">
            <label>
              Frozen:
              <select
                className="modal-input"
                id="ddlfrozen_flag"
                name="frozen_flag"
                onChange={handleChange}
              >
                <option value="N"
                  selected={"N" === formData?.frozen_flag}
                >No</option>
                <option value="Y"
                  selected={"Y" === formData?.frozen_flag}
                >Yes</option>
              </select>

            </label>
          </div>
          <div className="modal-column">
            <label>
              Frozen On:
              <input
                type="text"
                name="frozen_date"
                value={formData?.frozen_date?? ""}
                className="modal-input"
                onChange={handleChange}
                readOnly
              />

            </label>
          </div>
          
        </div>

        <div className="modal-row">
          <div className="modal-column input-group-text">
            <b>Agent Commission</b>
          </div>
        </div>
        <div className="modal-row">
          <div className="modal-column">
            <label>
              Agent Name:
              <select
                className="modal-input"
                id="ddlagent_key"
                name="agent_key"
                onChange={handleChange}
              >
                <option value="">[Select Agent]</option>
                {agentList.map((agent, i) => (
                  <option
                    key={i}
                    value={agent.agent_key}
                    selected={agent.agent_key === formData.agent_key}
                  >
                    {agent.agent_name}
                  </option>
                ))}
              </select>
            </label>
          </div>
          <div className="modal-column">
            <label>
              Commission:
              <select
                className="modal-input"
                id="ddlagent_commission_type"
                name="agent_commission_type"
                onChange={handleChange}
              >
                <option value="P"
                  selected={"P" === formData?.agent_commission_type}
                >Percent</option>
                <option value="R"
                  selected={"R" === formData?.agent_commission_type}
                >Report Based Fixed Rate</option>
                <option value="M"
                  selected={"M" === formData?.agent_commission_type}
                >More than Report Rate</option>
              </select>

            </label>
          </div>
          <div className="modal-column">
            <label>
              Percent/Amount:
              <input
                type="number"
                name="agent_commission_perc_or_amount"
                value={formData?.agent_commission_perc_or_amount ?? ""}
                className="modal-input"
                onChange={handleChange}
                min={0}
              />
            </label>
          </div>
          <div className="modal-column">
            <label>
              Include ECG:
              <select
                className="modal-input"
                id="ddlagent_commission_include_ecg"
                name="agent_commission_include_ecg"
                onChange={handleChange}
              >
                <option value="N"
                  selected={"N" === formData?.agent_commission_include_ecg}
                >No</option>
                <option value="Y"
                  selected={"Y" === formData?.agent_commission_include_ecg}
                >Yes</option>
              </select>

            </label>
          </div>

        </div>
        
      </div>

      <div className="modal-actions" style={{marginTop:"0px"}}>
        <div className="col-lg-4 col-4"><button type="button"
                className="btn btn-secondary btn-sm btn-block bi bi-save2-fill" id="btnCreditSave" onClick={() => onSave(formData)}> SAVE</button></div>
        <div className="col-lg-3 col-4"><button type="button"
                className="btn btn-secondary btn-sm btn-block bi bi-x-square" id="btnCreditClose" onClick={onClose}> CLOSE</button></div>
      </div>
    </div>
  );
}
